/**
 * Página 404 do Sistema MEDICARE
 * Página exibida quando uma rota não é encontrada
 */

import React from 'react';
import {
  Box,
  Button,
  Container,
  VStack,
  Text,
  Heading,
  useColorModeValue,
  Flex,
  Icon,
} from '@chakra-ui/react';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg={bgColor}
      px={4}
    >
      <Container maxW="md" textAlign="center">
        <VStack spacing={8}>
          {/* Número 404 estilizado */}
          <Box>
            <Text
              fontSize={{ base: '6xl', md: '8xl' }}
              fontWeight="bold"
              color="medicare.500"
              lineHeight="1"
            >
              404
            </Text>
          </Box>

          {/* Mensagens */}
          <VStack spacing={4}>
            <Heading
              size="xl"
              color={useColorModeValue('gray.800', 'gray.200')}
            >
              Página não encontrada
            </Heading>
            <Text
              fontSize="lg"
              color={textColor}
              maxW="md"
            >
              Ops! A página que você está procurando não existe ou foi movida.
            </Text>
          </VStack>

          {/* Botões de ação */}
          <VStack spacing={4} w="full" maxW="sm">
            <Button
              colorScheme="medicare"
              size="lg"
              w="full"
              leftIcon={<Icon as={FiHome} />}
              onClick={handleGoHome}
            >
              {isAuthenticated ? 'Ir para Dashboard' : 'Ir para Login'}
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              w="full"
              leftIcon={<Icon as={FiArrowLeft} />}
              onClick={handleGoBack}
            >
              Voltar
            </Button>
          </VStack>

          {/* Informação adicional */}
          <Box
            p={6}
            bg={useColorModeValue('white', 'gray.800')}
            borderRadius="lg"
            border="1px"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            w="full"
            maxW="md"
          >
            <VStack spacing={3}>
              <Text fontSize="sm" fontWeight="medium">
                Precisa de ajuda?
              </Text>
              <Text fontSize="sm" color={textColor}>
                Se você acredita que isso é um erro, entre em contato com o suporte técnico.
              </Text>
              <Text fontSize="xs" color={textColor}>
                Sistema MEDICARE v1.0.0
              </Text>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Flex>
  );
};

export default NotFoundPage;